export function renderBuildSelectOptionTypesComponentTemplate({
  ctxSingular,
  fieldNames,
  ctxCamelSingular,
  ctxPlural
}: {
  ctxSingular: string
  fieldNames: string
  ctxCamelSingular: string
  ctxPlural: string
}): string {
  return `export type ${ctxSingular}SelectOptionFieldName = ${fieldNames}

export interface ${ctxSingular}SelectOption {
  id: string
  fieldName: ${ctxSingular}SelectOptionFieldName
  label: string
  value: string
  createdAt: string
  updatedAt: string
}

export interface Create${ctxSingular}SelectOptionInput {
  fieldName: ${ctxSingular}SelectOptionFieldName
  label: string
}

export interface Create${ctxSingular}SelectOptionResult {
  success: boolean
  error?: string
  option?: ${ctxSingular}SelectOption
}

export const ${ctxCamelSingular}SelectOptionsCacheTags = {
  byField: (fieldName: ${ctxSingular}SelectOptionFieldName) => \`${ctxPlural}:select-options:\${fieldName}\`
} as const`
}
